import { isAxiosError } from "axios";

import { notify } from "@/components/kit";
import ProductFormModal from "@/components/product/modal/add-edit";
import { useImportScrapedProduct } from "@/hooks/api/scraped-product/useImportScrapedProduct";
import { AddProduct, Brand, Category } from "@/types";
import { ScrapedProduct } from "@/types/scraped-product";

interface ImportScrapedProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: ScrapedProduct;
}

export const ImportScrapedProductModal = ({
  isOpen,
  onClose,
  product,
}: ImportScrapedProductModalProps) => {
  const { mutate, isPending, isError, reset, error } =
    useImportScrapedProduct();

  const handleSave = (data: AddProduct) => {
    mutate(
      { id: product.id, data },
      {
        onSuccess: (data) => {
          notify.success(
            "Product imported successfully",
            `${product.name} was successfully imported under id: ${data.product?.id} `,
          );
          onClose();
        },
        onError: (error) => {
          let message = "Please try again and contact support";

          if (isAxiosError(error)) {
            if (error.message) {
              message = error.response?.data?.message;
            }
          }

          notify.error("Failed to import product", message);
        },
      },
    );
  };

  return (
    <ProductFormModal
      isImport
      error={error}
      isError={isError}
      isLoading={isPending}
      isOpen={isOpen}
      product={{
        description: product.description,
        externalId: product.externalId,
        id: product.id,
        images: product.images,
        inStock: product.stockAvailability,
        originalPrice: product.price,
        name: product.name,
        nameAr: "",
        supplier: product.supplier,
        tags: [],
        price: product.price,
        brand: {
          id: product.scrapedBrand?.linkedBrandId!,
        } as Brand,
        category: {
          id: product.scrapedCategory?.linkedCategoryId!,
        } as Category,
      }}
      resetMutation={reset}
      onClose={onClose}
      onSave={handleSave}
    />
  );
};
